import Layout from '@/layouts/Layout'

const workbench = {
  path: '/workbench',
  component: Layout,
  name: 'workbench',
  meta: {
    title: '工作台-新',
    icon: 'dashboard',
  },
  children: [
    {
      path: '/workbench/dashboard/list',
      name: 'workbench_index',
      component: () => import('@/pages/workbench/dashboard/list'),
      meta: { title: '工作台', logEvent: '' },
    },
    {
      path: '/workbench/dashboard/dataReport',
      name: 'workbench_data_board',
      component: () => import('@/pages/workbench/dataReport/list/index'),
      meta: { title: '数据看板', logEvent: '' },
    },
    {
      path: '/workbench/rentOrder/list',
      name: 'workbench_rent_order',
      component: () => import('@/pages/orders/personalOrder/list/listTab'),
      meta: { title: '个人租赁订单', logEvent: '' },
    },
    {
      path: '/workbench/rentOrder/add',
      name: 'workbench_rent_order_add',
      hidden: true,
      component: () => import('@/pages/orders/personalOrder/add/index'),
      meta: { title: '新增个人租赁订单',
        logEvent: '',
        parent: [
          {
            path: '/workbench/rentOrder/list',
            name: 'workbench_rent_order',
            title: '个人租赁订单',
          },
        ] },
    },
    {
      path: '/workbench/rentOrder/detail',
      name: 'workbench_rent_order_detail',
      hidden: true,
      component: () => import('@/pages/orders/personalOrder/detail'), // 和企业租赁子订单详情用同一个
      meta: { title: '租赁订单详情', logEvent: '' },
    },
    {
      path: '/workbench/entOrder/list',
      name: 'workbench_ent_rent_order',
      component: () => import('@/pages/orders/enterpriseOrder/list/index'),
      meta: { title: '企业租赁订单', logEvent: '' },
    },
    {
      path: '/workbench/entOrder/add',
      name: 'workbench_ent_rent_order_main_add',
      hidden: true,
      component: () => import('@/pages/orders/enterpriseOrder/add/index'),
      meta: { title: '企业租赁订单管理-新增', logEvent: '' },
    },
    {
      path: '/workbench/entOrder/add/rentalCar',
      name: 'workbench_ent_rent_order_main_add_car',
      hidden: true,
      component: () => import('@/pages/orders/enterpriseOrder/add/rentalCar.vue'),
      meta: { title: '新增租赁车辆', logEvent: '' },
    },
    {
      path: '/workbench/entOrder/detail',
      name: 'workbench_ent_rent_order_main_detail',
      hidden: true,
      component: () => import('@/pages/orders/enterpriseOrder/detail/index'),
      meta: { title: '企业租赁主订单管理-详情', logEvent: '' },
    },
    {
      path: '/workbench/entOrder/detail/child',
      name: 'workbench_ent_rent_order_sub_detail',
      hidden: true,
      component: () => import('@/pages/orders/enterpriseOrder/detail/child.vue'), // 和个人租赁订单详情用同一个
      meta: { title: '企业租赁订单管理-子订单详情', logEvent: '' },
    },
    {
      path: '/workbench/contractRelationRecord/list',
      name: 'workbench_contract_relation_record',
      component: () => import('@/pages/orders/contractRelationRecord/list/index'), // 和个人租赁订单详情用同一个
      meta: { title: '关联订单记录', logEvent: '' },
    },
    {
      // path: '/purchase/batchCollectionRecordAdd',
      path: '/workbench/batchCollectionRecordAdd',
      name: 'workbench_rent_order_to_receivable',
      hidden: true,
      component: () => import('@/pages/finance/AddCollection'),
      meta: { title: '新增订单收款', logEvent: '' },
    },
    {
      path: '/workbench/approval/detail',
      name: 'workbench_ent_rent_order_sub_transfer',
      hidden: true,
      component: () => import('@/pages/approvals/approveCenter/detail/index'),
      meta: { title: '企业关联订单审核中', logEvent: '' },
    },
    // 个人租赁子订单收款详情
    {
      path: '/workbench/order/collection/detail',
      name: 'workbench_rent_order_payment_detail',
      hidden: true,
      component: () => import('@/pages/orders/paymentDetail'),
      meta: { title: '订单收款详情', logEvent: '' },
    },
    // 企业租赁子订单收款详情
    {
      path: '/workbench/order/sub/collection/detail',
      name: 'workbench_ent_rent_order_sub_payment_detail',
      hidden: true,
      component: () => import('@/pages/orders/paymentDetail'),
      meta: { title: '订单收款详情', logEvent: '' },
    },
    // -------------待办----------------
    {
      path: '/workbench/todo',
      name: 'workbench_get_deal_with_list',
      component: () => import('@/pages/workbench/todo/todoCenter.vue'),
      meta: { title: '我的待办', logEvent: '' },
    },
  ],
}
export default workbench
